module.exports = __webpack_public_path__ + "static/media/icon_social-connect.1e233621.svg";